<template>
  <ParentPage
    class="Reporting"
    :menu="setMenu"
    :root-route-name="rootRouteName"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import { ReportingMenu } from '@/config'

import ParentPage from '@/components/ParentPage.vue'

// eslint-disable-next-line no-unused-vars
import { fetchProcessesByType } from '@/services/processes'

export default {
  name: 'Config',
  components: {
    ParentPage,
  },
  data() {
    return {
      menu: ReportingMenu,
      rootRouteName: 'Reporting',
    }
  },
  computed: {
    ...mapGetters('user', ['canAccessReporting']),
    ...mapGetters('tenant', ['getActiveProcessTypes']),
    ...mapGetters('processes', ['getProcessTableRecords']),

    setMenu () {
      const menu = JSON.parse(JSON.stringify(this.menu))
      menu.map(link => {
        link.label = link.label[this.$i18n.locale] || link.label
        if (link.items) {
          link.items.map(item => {
            item.label = item.label[this.$i18n.locale] || item.label
            return item
          })
        }

        return link
      })

      return menu
    },
    reportingRoute () {
      // For some reason, this comp. is loaded twice (route.replace in ParentPage) //
      // to select first avalilable menu item (e.g. RVBCustomers). Because of this, //
      // fetchProcessesByType is called twice and PrimeTable gives not unique error back //
      // This needs refactoring as soon as possible //
      return this.$route.name === 'Reporting'
    }
  },
  async created() {
    // Access check
    if (!this.canAccessReporting) {
      this.$router.push({
        name: 'Dashboard',
      })
    }

    if (process.env.VUE_APP_TENANT === 'rvb' && !this.reportingRoute){
      this.$store.dispatch('processes/setCurrentProcessType', { processType: 'private' })
      const token = await this.$auth.getTokenSilently()
      await fetchProcessesByType({ token, processType: 'private' }).catch(err => console.log(err))
    }
  },
}
</script>
